import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Button,
    MenuItem,
    Select,
    TextField,
    FormControl,
    InputLabel,
    IconButton,
    Typography,
    Alert
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';

import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useUpdatePayrate } from '../hooks/useUpdatePayrate';
import { EditIcon } from '../../../vectors/index';

type HoursWorkedEditModalProps = {
    handleClose: () => void;
    item: any;
};

const HoursWorkedEditModal: FC<HoursWorkedEditModalProps> = ({
    handleClose,
    item,
}) => {

    const [currentHoursAction, setCurrentHoursAction] = useState('add');
    const [currentHours, setCurrentHours] = useState(0);

    const [currentTipsAction, setCurrentTipsAction] = useState('add');
    const [currentTips, setCurrentTips] = useState(0);

    const [errorText, setErrorText] = useState('');
    const { updatePayrate, isUpdatePayrateLoading } = useUpdatePayrate({ setErrorText });

    const handleSave = () => {
        const tips = currentTipsAction === 'add' ? currentTips : parseFloat(`-${Math.abs(currentTips)}`);
        const hoursWorked = currentHoursAction === 'add' ? currentHours : parseFloat(`-${Math.abs(currentHours)}`);

        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message);
                handleClose();
            },
        };
        updatePayrate({
            application_id: item.id,
            pay_rate_type: item.pay_rate_type,
            pay_rate: item.pay_rate,
            tips: tips,
            hours_worked: hoursWorked,
        }, options);
    };

    const handleHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        if (!isNaN(value)) {
            setCurrentHours(value);
        }
    };

    const handleTipsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        if (!isNaN(value)) {
            setCurrentTips(value);
        }
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <EditIcon />
                <br />
                <Typography variant="h4" sx={{ p: 3 }}>
                    <b>{item.applicant.s_name}</b> - Hours Worked
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={2}>
                    {errorText && <Alert severity="error">{errorText}</Alert>}

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} mt={2}>
                        <FormControl sx={{ width: { xs: "100%", sm: '60%' } }}>
                            <Typography id="current-hours-action-label">Total Current Hours</Typography>
                            <Select
                                labelId="current-hours-action-label"
                                value={currentHoursAction}
                                onChange={(e) => setCurrentHoursAction(e.target.value)}
                                sx={{ width: '100%' }}
                                size='small'
                                MenuProps={{ PaperProps: { style: { borderRadius: 5 } } }}
                            >
                                <MenuItem value="add">Add Hours</MenuItem>
                                <MenuItem value="subtract">Subtract Hours</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: { xs: "100%", sm: '40%' } }}>
                            <Typography id="current-hours-action-label">{item.hours_worked}</Typography>
                            <TextField
                                variant="outlined"
                                type="number"
                                value={currentHours}
                                onChange={handleHoursChange}
                                size='small'
                                inputProps={{ step: 0.5 }}
                            />
                        </FormControl>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} mt={2}>
                        <FormControl sx={{ width: { xs: "100%", sm: '60%' } }}>
                            <Typography id="current-tips-action-label">Total Current Tips</Typography>
                            <Select
                                labelId="current-tips-action-label"
                                value={currentTipsAction}
                                onChange={(e) => setCurrentTipsAction(e.target.value)}
                                sx={{ width: '100%' }}
                                size='small'
                                MenuProps={{ PaperProps: { style: { borderRadius: 5 } } }}
                            >
                                <MenuItem value="add">Add Tips</MenuItem>
                                <MenuItem value="subtract">Subtract Tips</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: { xs: "100%", sm: '40%' } }}>
                            <Typography id="current-tips-action-label">{item.tips}</Typography>
                            <TextField
                                variant="outlined"
                                type="number"
                                value={currentTips}
                                onChange={handleTipsChange}
                                size='small'
                                inputProps={{ step: 0.01 }}
                            />
                        </FormControl>
                    </Stack>
                    <LoadingButton
                        startIcon={<DoneIcon />}
                        variant="contained"
                        color="primary"
                        loading={isUpdatePayrateLoading}
                        disabled={isUpdatePayrateLoading || !currentHours && !currentTips}
                        onClick={handleSave}>
                        Save
                    </LoadingButton>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default HoursWorkedEditModal;
